import { useLayoutEffect, useState } from "react";
import { measureHandZone, shouldCompactCaseMeters } from "./caseStatusDensity.js";

export function useCaseStatusDensity() {
  const [screen, setScreen] = useState<HTMLElement | null>(null);
  const [compact, setCompact] = useState(false);

  useLayoutEffect(() => {
    const zone = screen?.querySelector(".hand-zone");
    if (!screen || !(zone instanceof HTMLElement)) return;

    const update = () => {
      const measured = measureHandZone(zone);
      if (!measured) return;
      setCompact((current) => shouldCompactCaseMeters({ ...measured, compact: current }));
    };

    update();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(update);
    observer.observe(screen);
    observer.observe(zone);
    const stack = zone.querySelector(".hand-stack");
    if (stack instanceof HTMLElement) observer.observe(stack);
    return () => observer.disconnect();
  }, [screen]);

  return { screenRef: setScreen, compact };
}
